export type UserType = {
  id: number
  name: string
  email: string
  photo_url: null
  phone_number: string
  created_at: string
  updated_at: string
  newest_app_version: string
  in_app_messaging_enabled: true
  marketing_notifications_enabled: false
  email_validated_at: null
  store_ids: number[]
  role_ids: number[]
  permission_ids: number[]
  activity_log: ActivityLog[]
}

export type UserSearchResult = {
  id: number
  name: string
  email: string
}

export enum UserState {
  guest = 'guest',
  instore = 'instore',
  registered = 'registered',
  loyal = 'loyal',
}

export type NewUserType = Omit<UserType, 'id'>

export type UserFormType = {
  id?: number
  name: string
  email: string
  photo_url: string | null
  phone_number: string
  store_ids: number[]
  role_ids: number[]
  permission_ids: number[]
  manager_approval_code: string
  loyalty_number: string | null
  birthdate: string | null
}

type ActivityLog = {
  id: number
  log_name: string
  description: string
  causer_id: number | null
  created_at: string
  event: string
  batch_uuid: string | null
  properties: {
    attributes: Record<string, any>
    old: Record<string, any>
  }
}
